/**
 * @file Custom event manager to make event listeners outside zone.js
 * The CostumEventManager overrides the default Angular EventManager to solve performance issue's.
 * @see Providers of the app.module.ts
 * @see https://stackoverflow.com/questions/45227486/hostlistener-slowing-down-application-angular2
 * @author Tom Verschoore de la Houssaije.
 */
import * as tslib_1 from "tslib";
import { NgZone } from '@angular/core';
import { EventManager } from '@angular/platform-browser';
/**
 * Custom event manager to make event listeners outside zone.js
 * @see https://stackoverflow.com/questions/45227486/hostlistener-slowing-down-application-angular2
 * @export
 * @class CustomEventManager
 */
var CustomEventManager = /** @class */ (function (_super) {
    tslib_1.__extends(CustomEventManager, _super);
    /**
     * Creates an instance of CustomEventManager.
     * @param {any[]} plugins Angular plugins
     * @param {NgZone} zone Angular zone.js
     */
    function CustomEventManager(plugins, zone) {
        var _this = _super.call(this, plugins, zone) || this;
        _this.zone = zone;
        return _this;
    }
    /**
     * Adds a global event listener. Now with support of out of zone.
     * @param {string} element The html element.
     * @param {string} eventName The name of the event.
     * @param {Function} handler The event handler.
     * @returns {Function} The global event listener.
     * @example
     * @HostListener('document:keydown.out-zone', ['$event']) keyDown(event) {
     *  // Use .out-zone' to indicate out zone.js
     *  // some logic
     *  if ( condition1 && condition2 .... ) {
     *      // Refresh component your self.
     *      this.cd.detectChanges();
     *  }
     * }
     */
    CustomEventManager.prototype.addGlobalEventListener = function (element, eventName, handler) {
        var _this = this;
        if (eventName.endsWith('out-zone')) {
            eventName = eventName.split('.')[0];
            return this.zone.runOutsideAngular(function () {
                return _super.prototype.addGlobalEventListener.call(_this, element, eventName, handler);
            });
        }
        return _super.prototype.addGlobalEventListener.call(this, element, eventName, handler);
    };
    return CustomEventManager;
}(EventManager));
export { CustomEventManager };
